import React from 'react';
import "./BlankPage.css";

const BlankPage = () => {
    return (
        <div className='Blankpage'>
            <h2>404</h2>
            <h4>Not Found</h4>
        </div>
    );
};

export default BlankPage;